import * as React from 'react';

export default function Wifi({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 17.2724 12.6042'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.350363 4.66875C0.775363 5.09375 1.45036 5.13542 1.9087 4.75208C5.80036 1.55208 11.4504 1.55208 15.3504 4.74375C15.817 5.12708 16.5004 5.09375 16.9254 4.66875C17.417 4.17708 17.3837 3.36042 16.842 2.91875C12.0837 -0.972917 5.20036 -0.972917 0.433697 2.91875C-0.10797 3.35208 -0.149637 4.16875 0.350363 4.66875V4.66875ZM6.81703 11.1354L8.04203 12.3604C8.36703 12.6854 8.89203 12.6854 9.21703 12.3604L10.442 11.1354C10.8337 10.7437 10.7504 10.0687 10.2504 9.81042C9.2337 9.28542 8.01703 9.28542 6.99203 9.81042C6.51703 10.0687 6.42536 10.7437 6.81703 11.1354ZM3.7087 8.02708C4.11703 8.43542 4.7587 8.47708 5.2337 8.13542C7.26703 6.69375 10.0004 6.69375 12.0337 8.13542C12.5087 8.46875 13.1504 8.43542 13.5587 8.02708L13.567 8.01875C14.067 7.51875 14.0337 6.66875 13.4587 6.26042C10.592 4.18542 6.6837 4.18542 3.8087 6.26042C3.2337 6.67708 3.20036 7.51875 3.7087 8.02708V8.02708Z"
        fill="currentColor"
      />
    </svg>
  );
}
